// /* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import { useContext } from "react";
import { InjectedIntl } from "react-intl";
import { injectIntl } from "react-intl-phraseapp";
import { Window } from "../@types";
import EnglishTranslations from "../translations/en-US.json";
declare let window: Window;

export const IntlContext = React.createContext<InjectedIntl>(
  {} as InjectedIntl
);

// turn the old context into the new context
export const InjectIntlContext = injectIntl(
  ({
    intl,
    children,
  }: {
    intl: InjectedIntl;
    children: React.ReactChildren;
  }) => {
    return <IntlContext.Provider value={intl}>{children}</IntlContext.Provider>;
  }
);

// Allows for intellisense autocomplete of PA key names
export type TranslationKey = keyof typeof EnglishTranslations;

// Makes PhraseApp compatible ID strings, for use with the in context editor
const phraseappEscapeId = (id: string): string => `{{__phrase_${id}__}}`;

// the format message hook
export const useFormatMessage = (): Function => {
  const intl = useContext(IntlContext);

  if ((window as Window).PHRASEAPP_ENABLED) {
    return ({ id }: { id: string }): string => phraseappEscapeId(id);
  } else {
    return intl.formatMessage;
  }
};

export const useIntl = (): InjectedIntl => {
  return useContext(IntlContext);
};

export const useTranslate = (): ((id: TranslationKey | string) => string) => {
  const fm = useFormatMessage();
  return (id: string): string => {
    if (!EnglishTranslations[id]) {
      return id;
    }

    if ((window as Window).PHRASEAPP_ENABLED) {
      return phraseappEscapeId(id);
    } else {
      return fm({ id });
    }
  };
};
